import { render, staticRenderFns } from "./SchoolClassItem.vue?vue&type=template&id=ec160814"
import script from "./SchoolClassItem.vue?vue&type=script&lang=js"
export * from "./SchoolClassItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports